import { useAppDispatch, useAppSelector } from 'app/hooks';
import { toggleCollapsed } from 'app/slices/dashboardSlice';

/**
 * Left rail collapse toggle (§3.B). A hidden checkbox (#left_resizer) + visible
 * label. The pure-CSS collapse hooks key off `.left-menu-resizer:checked ~ #statuses`
 * / `~ #container` (both siblings inside #ksdm-content), so the checkbox MUST be a
 * sibling preceding #statuses/#container. Footer reflow is handled in React
 * (PageFooter reads `collapsed`) since the footer is not a CSS sibling of the
 * resizer in this DOM.
 *
 * Expanded: hamburger + "tasks" + collapse arrow. Collapsed: label shrinks to
 * 53px (CSS), icon-only rail, tooltips via .ka-has-tooltip.
 */
const LeftResizer = () => {
  const dispatch = useAppDispatch();
  const collapsed = useAppSelector((s) => s.dashboard.collapsed);

  return (
    <>
      <input
        id="left_resizer"
        className="left-menu-resizer whiteboard-resizer"
        type="checkbox"
        checked={collapsed}
        onChange={() => dispatch(toggleCollapsed())}
      />
      <label htmlFor="left_resizer" className="ka-has-tooltip col-xs-2" tooltip="Tasks">
        <i className="icon-hamburger" />
        <h2>tasks</h2>
        <i className="icon-angle-left ka-has-tooltip" tooltip="Collapse" />
      </label>
    </>
  );
};

export default LeftResizer;
